import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import React, { useEffect } from 'react';
import { usePaypal } from '../../business/processors/recurly/PaypalService';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { PayPalButton, PayPalImage } from './styled';
export var RecurlyPayPal = function RecurlyPayPal() {
  var config = useAppSelector(configSelector);
  var appConstants = config.appConstants,
    rioNamespace = config.rioNamespace;
  var _ref = appConstants,
    cdnUrl = _ref.cdnUrl;
  var onPaypalClick = usePaypal();
  useEffect(function () {
    // RIO Logging: Paypal button display successfully
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PAYPAL_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, []);
  return /*#__PURE__*/React.createElement(PayPalButton, {
    onClick: onPaypalClick,
    "data-test": DataTestAttributes.RECURLY_PAYPAL_BUTTON
  }, /*#__PURE__*/React.createElement(PayPalImage, {
    src: "".concat(cdnUrl, "site/logos/PayPal.png"),
    "aria-label": "PayPal",
    height: 20,
    width: 15
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PayPal/RecurlyPayPal.js
// module id = 4626
// module chunks = 11